import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';

import {
  ChangeDeliveryTypeDto,
  ChangeDeliveryTypeStore,
  DeliveryTypeDto
} from '../../../../../stores/configuration/events-n-requests/delivery-types-store';
import { nameof } from '../../../../../utils/object';

interface ChangeDeliveryTypeViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  changeDeliveryType?: ChangeDeliveryTypeStore;
  currentDeliveryType: DeliveryTypeDto;
}

// tslint:disable-next-line:no-empty-interface
interface ChangeDeliveryTypeViewState {}

@connect(['changeDeliveryType', ChangeDeliveryTypeStore])
class ChangeDeliveryTypeView extends React.Component<ChangeDeliveryTypeViewProps, ChangeDeliveryTypeViewState> {
  private get changeDeliveryTypeStore() {
    return this.props.changeDeliveryType;
  }

  constructor(props: ChangeDeliveryTypeViewProps) {
    super(props);

    this.changeDeliveryTypeStore.state.result = null;

    this.changeDeliveryTypeStore.change({
      id: this.props.currentDeliveryType.id,
      name: this.props.currentDeliveryType.name
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: ChangeDeliveryTypeViewProps) {
    if (this.changeDeliveryTypeStore.state.result && this.changeDeliveryTypeStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onChangeItem() {
    this.changeDeliveryTypeStore.update();
  }

  @autobind
  private onCancelChangeItem() {
    this.changeDeliveryTypeStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.changeDeliveryTypeStore.change({ ...this.changeDeliveryTypeStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelChangeItem} closeOnDimmerClick={false}>
        <Dimmer active={this.changeDeliveryTypeStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('Edit Delivery Type')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.changeDeliveryTypeStore.state.result && !this.changeDeliveryTypeStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.changeDeliveryTypeStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.changeDeliveryTypeStore.state.item && (
              <Form loading={this.changeDeliveryTypeStore.state.isBusy}>
                <Form.Field>
                  <Form.Input
                    required
                    fluid
                    label={t('Delivery Type')}
                    placeholder={t('Name')}
                    value={this.changeDeliveryTypeStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<ChangeDeliveryTypeDto>('name'), value)}
                  />
                </Form.Field>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelChangeItem}>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onChangeItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(ChangeDeliveryTypeView);
